<template>
  <a-form  ref="ruleForm" :model="form" :rules="rules" :label-col="{span:5}" :wrapper-col="{span:18}">
    <a-form-item label="条件设置" required>
           <a-radio-group v-model:value="form.tag_type">
              <a-radio :value="1">
                指定次数打标签
              </a-radio>
              <a-radio :value="2">
                指定地区打标签
              </a-radio>
            </a-radio-group>
    </a-form-item>
    <a-form-item label="用户扫码达" name="award_count" v-if="form.tag_type==1">
          <a-input-number v-model:value="form.award_count" :min="1" :max="100" :precision="0"></a-input-number> <span class="s_c666">（限1-100整数）</span>  次时系统自动打标签
    </a-form-item>
    <a-form-item label="领奖地区" name="province" v-if="form.tag_type==2" >
           <selectCity  :addressData='region'  placeholder="所在地区" v-on:citychange='citychange' />
    </a-form-item>
    <a-form-item label="选择标签" name="tag_ids">
        <a-select v-model:value="form.tag_ids" style="width:100%" mode="multiple" @change="changeTags">
            <a-select-option v-for='item in options' :key='item.tag_name' :value="item.id" >{{item.tag_name}}</a-select-option>
        </a-select>
    </a-form-item>
        <div class="s_flex_center">
            <a-button @click="submit" type="primary" class='m-r-10'>确认</a-button>
            <a-button @click="cancel"  class='m-r-10'>取消</a-button>
    </div>
  </a-form>
</template>
<script>
import {  getMemberTagList} from '@/api/member'
import { onMounted, ref } from 'vue'
import { iscode } from '../../../../../utils/app'
const rules={
  tag_ids:[{required:true,message:"请选择标签",type:'array'}],
  award_count:[{required:true,message:"请输入次数",type:'number'}],
  province:[{required:true,message:"请选择地区"}]
}
export default {
  setup(props,{emit}){
      const ruleForm=ref()
      const form=ref({
        tag_type:1,
        award_count:null,
        tag_ids:[],
        tag_names:[],
        province_id:'',
        province:'',
        city_id:'',
        city:'',
        district_id:'',
        district:''
      })
      const region=ref([])
          //获取标签
      const options=ref([])
      const getTagsList = async () => {
        let res = await getMemberTagList({limit:99}).then((res) => res.data);
        if (iscode(res)) {
          options.value = res.data.data;
        }
      };
      // 标签改变事件
      const changeTags=(e,data)=>{
        form.value.tag_names=data.map(v=>v.key)
      }

      // 地区选择
      const citychange=(e,data)=>{
        form.value.province_id=e[0]
        form.value.province=data[0].name
        form.value.city_id=e[1]
        form.value.city=data[1].name
        form.value.district_id=e[2]
        form.value.district=data[2].name
    
      }
      onMounted(()=>{
        getTagsList()
      })
      // 确认
      const submit=()=>{
          ruleForm.value.validate().then(async () => {
               emit('confirm',form.value)
          })
      }
      const cancel=()=>{
          emit('cancel',1)
      }
      // 获取详情
      const detail=(data)=>{
        region.value=[data.province_id,data.city_id,data.district_id]
        form.value=data
      }
      return{
        rules,
        ruleForm,
        form,
        options,
        changeTags,
        citychange,
        region,
        submit,
        detail,
        cancel
      }
  }
}
</script>